import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ChatBot from '../../contactUs/components/ChatBot';
import ArticlePanel from './ArticlePanel';
import { loadModalContainer } from '../../contactUs/actions/action-login-modal';
import { chatBotClickedAction } from '../../contactUs/actions/action-chat-bot';
import Page from '../../lib/page';
import { getModalChannelType } from '../../lib/globalHelper';
import { setArticlePageChatBotClickInSession } from '../../lib/chat-bot-live-helper';

const isLoggedIn = Page.isLoggedIn();
const articleFaqId = Page.getArticleIdLowerCase();

class ArticleChatBotContainer extends Component {
  constructor(props) {
    super(props);
    this.chatBotClicked = this.chatBotClicked.bind(this);
  }

  chatBotClicked(isAsyncUser) {
    // Let's open up the login modal.
    if (!isLoggedIn) {
      this.props.chatBotClickedAction();
      setArticlePageChatBotClickInSession(true);

      // Open messageUs/ChatBot login modal window based on user is Async/Non Async user.
      return this.props.loadModalContainer(getModalChannelType(isAsyncUser));
    }
    return null;
  }

  render() {
    const { chatBotDisplay, chatBotAsync, isInputFocused } = this.props;
    //  SearchBox is focused return true or false
    function isSearchInputBoxFocused() {
      if (Page.isMobileLayout()) {
        return isInputFocused;
      }
      return false;
    }

    if (!chatBotDisplay) {
      return (<ArticlePanel />);
    }
    return (
      <div>
        <ArticlePanel />
        <ChatBot
          link="smarthelp-chat-bot-article"
          id="chatBotArticle"
          topicRefId="GENPOOL|articlePage"
          hpid={articleFaqId}
          display={chatBotDisplay}
          chatBotClicked={this.chatBotClicked}
          isChatBotAsyncUser={chatBotAsync}
          isSearchInputBoxFocused={isSearchInputBoxFocused}
        />
      </div>
    );
  }
}

ArticleChatBotContainer.propTypes = {
  loadModalContainer: PropTypes.func.isRequired,
  chatBotClickedAction: PropTypes.func,
  chatBotDisplay: PropTypes.string.isRequired,
  chatBotAsync: PropTypes.bool.isRequired,
  isInputFocused: PropTypes.bool.isRequired,
};

ArticleChatBotContainer.defaultProps = {
  chatBotClickedAction: () => {},
  postChatBotEligibility: () => {},
};

// Get the postChatBotEligibility redux data and Pass it as Props.
function mapStateToProps(state) {
  return {
    chatBotDisplay: state.postChatBotEligibility.chatBotDisplay,
    chatBotAsync: state.postChatBotEligibility.chatBotAsync,
    isInputFocused: state.contactReason.isInputFocused,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ loadModalContainer, chatBotClickedAction }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleChatBotContainer);
